import { useEffect, useState } from 'react';

import { CategoryCreate } from '../Category';

import { FormikSelect } from '@components/Form';
import { Modal } from '@components/Modal';
import { useCategorySelectOptions } from '@hooks/useCategorySelectOptions';

interface Props {
  selectedValue: string | number;
  onValueChange: (value: string) => void;
}

export const CategorySelector: React.FC<Props> = ({
  selectedValue,
  onValueChange,
}) => {
  const { categorySelectOptions, loadData, isLoading } =
    useCategorySelectOptions();
  const [createCategory, setShowCreateCategory] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    console.log('Value selected:', value);

    if (value === 'ADD_NEW') {
      setShowCreateCategory(true);
    } else {
      onValueChange(value);
    }
  };

  const handleClose = (refresh?: boolean, newId?: string) => {
    setShowCreateCategory(false);

    if (refresh) {
      loadData();
      if (newId) {
        onValueChange(newId);
      }
    } else {
      onValueChange('0');
    }
  };

  return (
    <>
      <FormikSelect
        label="Category"
        name="categoryID"
        value={selectedValue}
        selection={categorySelectOptions}
        onChange={handleSelectChange}
        disabled={isLoading}
      />

      {createCategory && (
        <Modal show={true}>
          <CategoryCreate onClose={handleClose} />
        </Modal>
      )}
    </>
  );
};
